export default __webpack_public_path__ + "static/media/CritiCare-Plus-Brochure.064f7df9.pdf";